import { render, staticRenderFns } from "./StaffListRoute.vue?vue&type=template&id=575f19a4&"
import script from "./StaffListRoute.vue?vue&type=script&lang=js&"
export * from "./StaffListRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports